export default __webpack_public_path__ + "static/media/success-check.c1367b13.svg";